module.exports = {"data":{"site":{"siteMetadata":{"title":"Razy Technologies"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/leveraging-cloud-services-results-in-seamless-distribution-of-lubricant-oil-in-mena/"},"frontmatter":{"title":"Leveraging Cloud Services Results in Seamless Distribution of Lubricant Oil in MENA"}}}]}},"pathContext":{"tag":"campaign"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-campaign.json
// module id = 453
// module chunks = 228838709679423